import { ChartTimelineVariantIcon } from './ChartTimelineVariantIcon';

/**
 * author: Google
 * id F41D980A-439A-4F1B-A3B7-850EB1A70416
 * name chart-timeline-variant
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chart-timeline-variant.svg
 * tags
 * - Math 
 */
export const ReportTimelineVariantIcon = ChartTimelineVariantIcon;
export default ReportTimelineVariantIcon